import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./AppDetail.css";
import MainContent from "../Components/MainContent";
import {
  Container,
  Card,
  Spinner,
  Alert,
  Row,
  Col,
  Button,
  Badge,
  Form,
  Accordion,
} from "react-bootstrap";
import {
  FaStar,
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaEnvelope,
} from "react-icons/fa";
import toast from "react-hot-toast";

const API_KEY = process.env.REACT_APP_API_URL

export function AppDetail() {

  const { id } = useParams();
  const [app, setApp] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [comment, setComment] = useState("");
  const [reviews, setReviews] = useState([]);

  const userData = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    fetch(`${API_KEY}/api/apps/${id}`)
      .then((res) => {
        if (!res.ok) throw new Error("App not found");
        return res.json();
      })
      .then((data) => {
        setApp(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });

    fetch(`${API_KEY}/api/reviews?appId=${id}`)
      .then((res) => res.json())
      .then((data) => setReviews(data))
      .catch(() => {});
  }, [id]);

  const handleReviewSubmit = (e) => {
    e.preventDefault();
    // setSubmitError("");
    // setSubmitSuccess("");

    if (!userData) {
      toast.error("You must be logged in to submit a review..");
      return;
    }

    fetch(`${API_KEY}/api/reviews`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId: userData.user._id,
        appId: id,
        rating,
        comment,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to submit review");
        return res.json();
      })
      .then((data) => {
        toast.success("Review submitted successfully.");
        setRating(0);
        setHoverRating(0);
        setComment("");
        setReviews([...reviews, data]);
      })
      .catch((err) => toast.error(err.message || "Error in review"));
  };

  const renderStars = () => {
    return [...Array(5)].map((_, index) => {
      const currentRating = index + 1;

      return (
        <FaStar
          key={index}
          size={24}
          className="me-1"
          style={{ cursor: "pointer" }}
          color={
            currentRating <= (hoverRating || rating) ? "#ffc107" : "#e4e5e9"
          }
          onClick={() => setRating(currentRating)}
          onMouseEnter={() => setHoverRating(currentRating)}
          onMouseLeave={() => setHoverRating(0)}
        />
      );
    });
  };

  if (loading)
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <Container className="my-5 pt-5 px-md-5 px-2">
      <Row>
        <Col md={7}>
          <div
            style={{
              display: "flex",
              // justifyContent: "center",
              alignItems: "center",
              gap: "40px",
              flexWrap: "wrap",
              // marginBottom: "20px"
            }}
          >
            <h2 style={{ fontSize: "40px", fontWeight: "bolder", margin: 0 }}>
              {app.name}
            </h2>

            <Button
              variant="primary"
              href={app.link}
              target="_blank"
              rel="noopener noreferrer"
              className="border-0 rounded-1"
              style={{ backgroundColor: "#7251e6", whiteSpace: "nowrap" }}
            >
              🔗 Open site
            </Button>
          </div>

          <div
            className="star-rating"
            style={{ color: "#7251e6", fontSize: "1.6rem" }}
          >
            ★★★★★
            <span style={{ color: "#000000", fontSize: "1.5rem" }}> 5 </span>
          </div>
          <br />
          <div
            style={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "16px",
              lineHeight: "1.8",
            }}
          >
            <div className="mb-3" style={{ marginBottom: "16px" }}>
              <strong
                style={{
                  fontWeight: "600",
                  minWidth: "150px",
                  display: "inline-block",
                }}
              >
                Introduction:
              </strong>
              <span style={{ color: "#555" }}>{app.description}</span>
            </div>

            <div className="mb-3" style={{ marginBottom: "16px" }}>
              <strong
                style={{
                  fontWeight: "600",
                  minWidth: "150px",
                  display: "inline-block",
                }}
              >
                Added on:
              </strong>
              <span style={{ color: "#555" }}>
                {new Date(app.added_on).toLocaleDateString()}
              </span>
            </div>

            <div className="mb-3" style={{ marginBottom: "16px" }}>
              <strong
                style={{
                  fontWeight: "600",
                  minWidth: "150px",
                  display: "inline-block",
                }}
              >
                Monthly Visitors:
              </strong>
              <span style={{ color: "#555" }}>{app.monthly_visitors}</span>
            </div>

            <div
              className="mb-3 d-flex gap-2 align-items-start"
              style={{ marginBottom: "16px" }}
            >
              <strong style={{ fontWeight: "600", minWidth: "150px" }}>
                Social & Email:
              </strong>
              {/* Yahan aap social/email links ya components render karo */}
              {app.company_facebook ? (
                <a
                  href={app.company_facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook size={20} color="#4267B2" />
                </a>
              ) : (
                "--"
              )}

              {app.company_instagram ? (
                <a
                  href={app.company_instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram size={20} color="#E1306C" />
                </a>
              ) : (
                "--"
              )}

              {app.company_twitter ? (
                <a
                  href={app.company_twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTwitter size={20} color="#1DA1F2" />
                </a>
              ) : (
                "--"
              )}

              {app.company_linkedin ? (
                <a
                  href={app.company_linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin size={20} color="#0077b5" />
                </a>
              ) : (
                "--"
              )}

              {app.company_email ? (
                <a href={`mailto:${app.company_email}`}>
                  <FaEnvelope size={20} color="#EA4335" />
                </a>
              ) : (
                "--"
              )}
            </div>
          </div>

          {app.social_tags && app.social_tags.length > 0 && (
            <div className="tags-area mt-4">
              {app.social_tags.map((tag, index) => (
                <button key={index} className="tag-button">
                  {tag}
                </button>
              ))}
            </div>
          )}

          <div className="mb-3">
            {(app.categories || []).map((cat, index) => (
              <Badge
                key={index}
                bg="light"
                text="dark"
                className="me-2 mb-2 p-2 rounded-pill border"
              >
                {cat}
              </Badge>
            ))}
          </div>
        </Col>

        <Col md={5} className="text-center">
          <div className="tool-card p-3 mb-3">
            <div className=" mt-2 me-2 d-flex gap-2 justify-content-start justify-content-md-end">
              <span className="text-muted small p-2">
                <i className="bi bi-star"></i> 0
              </span>
              <i className="bi bi-twitter text-purple  bg-white p-2"></i>
              <i className="bi bi-facebook text-purple  bg-white p-2"></i>
            </div>
            <div className="mt-3">
              <img
                // src={app?.company_image || "/images/Capture.png"}
                src={`${API_KEY}/temp/${app?.company_image}`}
                alt={app.name}
                className="img-fluid rounded-3 border"
                style={{ maxHeight: "350px", objectFit: "cover" }}
              />
            </div>

            <div className="d-flex justify-content-start justify-content-md-end gap-2 mt-3">
              <button className="btn btn-outline-purple btn-sm">
                Advertise this tool
              </button>
              <button className="btn btn-purple btn-sm text-white">
                Update this tool
              </button>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <div className="d-flex justify-content-start mb-4 flex-wrap border-bottom px-md-0">
          {[
            { label: "Product Information", id: "product-info" },
            { label: "Reviews", id: "reviews" },
            { label: "Pricing", id: "pricing" },
            { label: "Analytics", id: "analytics" },
            { label: "Embed", id: "embed" },
            { label: "Alternatives", id: "alternatives" },
          ].map((tab, idx) => (
            <div key={idx} className="text-left position-relative">
              <div
                onClick={() =>
                  document
                    .getElementById(tab.id)
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                className={`badge fw-bold px-3 py-2 text-dark`}
                style={{
                  fontSize: "14px",
                  borderRadius: 0,
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  color: "#7150e6",
                }}
              >
                {tab.label}
              </div>
            </div>
          ))}
        </div>
      </Row>

      {/* SHOW ALL CATEGORY CARDS */}
      {/* <Row>

        <MainContent />

      </Row> */}

      <Row
        className="px-3 px-md-0"
        style={{
          fontFamily: "Poppins, sans-serif",
          fontSize: "16px",
          lineHeight: "1.8",
        }}
      >
        <div className="mb-4 text-left p-md-0">
          <h3 className="fw-bold mt-5" style={{ fontSize: "30px" }}>
            {app.name} Product Information
          </h3>
        </div>

        <Card className="mb-3">
          <Card.Body>
            {/* What is section */}
            {app?.question_info?.description ? (
              <div className="mb-4">
                <h4 className="fw-bold" style={{ fontSize: "24px" }}>
                  What is {app.name || "Name not found"}?
                </h4>
                <p style={{ color: "#444" }}>
                  {app?.question_info?.description}
                </p>
              </div>
            ) : (
              <p>No Question provided yet. Please check back later.</p>
            )}

            <hr />

            {/* How to use */}
            {app?.how_to_use?.description ? (
              <div className="mb-4">
                <h4 className="fw-bold" style={{ fontSize: "24px" }}>
                  How to use {app.name || "Name not found"}
                </h4>
                <p style={{ color: "#444" }}>{app.how_to_use.description}</p>
              </div>
            ) : (
              <p>No usage information provided yet. Please check back later.</p>
            )}

            <hr />

            {/* Core Features */}
            <div className="mb-4">
              <h4 className="fw-bold" style={{ fontSize: "24px" }}>
                {app.name || "Name is not found"} Core Features
              </h4>
              <ul className="list-unstyled mt-2">
                {app?.core_features && app.core_features.length > 0 ? (
                  app.core_features.map((feature, index) => (
                    <li key={index} style={{ marginBottom: "8px" }}>
                      <i
                        className="bi bi-check-circle-fill pe-2"
                        style={{ color: "#7150e6", fontSize: "18px" }}
                      ></i>
                      {feature}
                    </li>
                  ))
                ) : (
                  <li>No core features available.</li>
                )}
              </ul>
            </div>

            <hr />

            {/* FAQs */}
            <div className="mb-4">
              <h4 className="fw-bold" style={{ fontSize: "24px" }}>
                FAQ about {app.name || "Name not found"}
              </h4>
              <Accordion>
                {app?.faqs && app.faqs.length > 0 ? (
                  app.faqs.map((faq, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index}>
                      <Accordion.Header>
                        {faq.question || "No question provided."}
                      </Accordion.Header>
                      <Accordion.Body>
                        {faq.answer || "No answer provided."}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))
                ) : (
                  <p className="mt-2">No FAQs available yet.</p>
                )}
              </Accordion>
            </div>
          </Card.Body>

          {/* Support Section */}
          <div className="px-3 px-md-4 mb-4">
            <h4 className="fw-bold mb-2">
              {app.name || "Name not found"} Support
            </h4>
            <p>
              Customer service:{" "}
              <a
                href={`mailto:${app.company_email}`}
                className="text-primary text-decoration-underline"
              >
                {app.company_email || "Email not provided"}
              </a>
              <br />
              More help:{" "}
              <a
                href={app.contact_url}
                className="text-primary text-decoration-underline"
              >
                {app.contact_url || "Contact page not found"}
              </a>
            </p>
          </div>

          <hr />

          {/* Company Info */}
          <div className="px-3 px-md-4 mb-4">
            <h4 className="fw-bold mb-2">
              {app.name || "Name not found"} Company
            </h4>
            <p>
              Company Name: <strong>{app.name || "Name not found"}</strong>
            </p>
            <p>
              Address:{" "}
              <strong>{app.company_address || "Address not provided"}</strong>
            </p>
            <p>
              Learn more:{" "}
              <a
                href={app.about_url}
                className="text-primary text-decoration-underline"
              >
                {app.about_url || "About page not found"}
              </a>
            </p>
          </div>

          <hr />

          {/* Login */}
          <div className="px-3 px-md-4 mb-4">
            <h4 className="fw-bold mb-2">
              {app.name || "Name not found"} Login
            </h4>
            <p>
              Access here:{" "}
              <a
                href={app.login_url}
                className="text-primary text-decoration-underline"
              >
                {app.login_url || "Login link not available"}
              </a>
            </p>
          </div>

          <hr />

          {/* Signup */}
          <div className="px-3 px-md-4 mb-4">
            <h4 className="fw-bold mb-2">
              {app.name || "Name not found"} Sign Up
            </h4>
            <p>
              Sign up here:{" "}
              <a
                href={app.signup_url}
                className="text-primary text-decoration-underline"
              >
                {app.signup_url || "Signup link not available"}
              </a>
            </p>
          </div>

          <hr />

          {/* Pricing */}
          <div className="px-3 px-md-4 mb-4">
            <h4 className="fw-bold mb-2">
              {app.name || "Name not found"} Pricing
            </h4>
            <p>
              View pricing:{" "}
              <a
                href={app.company_price}
                className="text-primary text-decoration-underline"
              >
                {app.company_price || "Pricing link not available"}
              </a>
            </p>
          </div>
        </Card>
      </Row>

      {/* next */}

      <Row
        className="px-3 px-md-0"
        id="reviews"
        style={{ fontFamily: "Poppins, sans-serif" }}
      >
        {/* Review Form */}
        <Card className="mt-5">
          <Card.Body>
            <h4 className="fw-bold mb-3" style={{ fontSize: "22px" }}>
              Leave a Review
            </h4>

            {/* {submitError && <Alert variant="danger">{submitError}</Alert>}
            {submitSuccess && <Alert variant="success">{submitSuccess}</Alert>} */}

            <Form onSubmit={handleReviewSubmit}>
              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">Rating:</Form.Label>
                <div className="d-flex align-items-center gap-1">
                  {renderStars()}
                </div>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">Comment:</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  required
                  placeholder="Write your review here..."
                  style={{ fontSize: "15px" }}
                />
              </Form.Group>

              <Button
                type="submit"
                className="border-0"
                variant="success"
                style={{
                  backgroundColor: "#7150e6",
                  padding: "10px 20px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  borderRadius: "6px",
                }}
              >
                Submit Review
              </Button>
            </Form>
          </Card.Body>
        </Card>

        {/* Display Reviews */}
        <Card className="mt-5 mb-5">
          <Card.Body>
            <h4 className="fw-bold mb-3" style={{ fontSize: "22px" }}>
              Reviews
            </h4>

            {reviews.length === 0 ? (
              <p className="text-muted">No reviews yet.</p>
            ) : (
              reviews.map((r, index) => (
                <div key={index} className="border-bottom pb-3 mb-3">
                  <div className="d-flex align-items-center mb-1">
                    {[...Array(5)].map((_, i) => (
                      <FaStar
                        key={i}
                        size={18}
                        color={i < r.rating ? "#ffc107" : "#e4e5e9"}
                        className="me-1"
                      />
                    ))}
                  </div>
                  <p
                    className="mb-1"
                    style={{ fontSize: "15px", color: "#444" }}
                  >
                    {r.comment}
                  </p>
                  {/* <small className="text-muted">User: {r.userId}</small> */}
                </div>
              ))
            )}
          </Card.Body>
        </Card>
      </Row>

      {/* === PRICING SECTION === */}
      <Row>
        <h2 className="fw-semibold fs-4 mt-5">
          {app.name || "Name not found"} Pricing
        </h2>
      </Row>

      <Row className="px-3 px-md-0" id="pricing">
        <div
          className="col-md-12 bg-white p-3"
          style={{ border: "1px solid #0000002d", borderRadius: "6px" }}
        >
          <div className="row">
            {app?.pricing?.length > 0 ? (
              app.pricing.map((item, idx) => (
                <div className="col-md-4 mb-3" key={idx}>
                  <Card className="h-100 shadow-sm border-0">
                    <Card.Body>
                      <h5 className="fw-bold text-primary">
                        {item.plan || "Plan not found"}
                      </h5>
                      <p className="mb-1">
                        {item.price !== undefined
                          ? `$${item.price}`
                          : "Price not found"}
                      </p>
                      <p className="pt-2 fs-6 text-muted">
                        {item.priceDescription || "Description not found"}
                      </p>
                    </Card.Body>
                  </Card>
                </div>
              ))
            ) : (
              <p>No pricing plans available.</p>
            )}
          </div>
        </div>
      </Row>

      {/* === ANALYTICS SECTION === */}
      <Row className="px-3 px-md-0" id="analytics">
        <div
          className="card my-4 shadow-sm"
          style={{
            borderRadius: "6px",
            backgroundColor: "#fff",
            border: "1px solid #0000002d",
          }}
        >
          {/* Header */}
          <div
            className="card-header bg-white border-0 fw-bold"
            style={{
              fontSize: "18px",
              padding: "16px 24px",
              color: "#212529",
            }}
          >
            🟣 Piny Website Traffic Analysis
          </div>

          {/* Body */}
          <div
            className="card-body pt-0"
            style={{ padding: "0 24px 24px 24px" }}
          >
            {/* Section Title */}
            <div
              className="d-flex align-items-center mb-3"
              style={{ marginTop: "-8px" }}
            >
              <div
                style={{
                  width: "4px",
                  height: "16px",
                  backgroundColor: "#007bff",
                  marginRight: "8px",
                  borderRadius: "2px",
                }}
              ></div>
              <h6
                className="fw-bold mb-0"
                style={{
                  fontSize: "14px",
                  color: "#000",
                }}
              >
                Visit Over Time
              </h6>
            </div>

            {/* Date and Chart Row */}
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
              {/* Date Range */}
              <div className="d-flex flex-column">
                <span
                  className="text-muted"
                  style={{
                    fontSize: "13px",
                    marginTop: "4px",
                  }}
                >
                  <i className="bi bi-calendar3 me-1"></i> Feb 2025 - Apr 2025
                  All Traffic
                </span>
                <ul
                  className="list-group list-group-flush border p-2 mt-2"
                  style={{ fontSize: "13px" }}
                >
                  <li className="list-group-item px-0 d-flex justify-content-between align-items-center">
                    Monthly Visits
                    <span className="text-muted fw-semibold">--</span>
                  </li>
                  <li className="list-group-item px-0 d-flex justify-content-between align-items-center">
                    Avg. Visit Duration
                    <span className="text-muted fw-semibold">00:00:00</span>
                  </li>
                  <li className="list-group-item px-0 d-flex justify-content-between align-items-center">
                    Page per Visit
                    <span className="text-muted fw-semibold">0.00</span>
                  </li>
                  <li className="list-group-item px-0 d-flex justify-content-between align-items-center">
                    Bounce Rate
                    <span className="text-muted fw-semibold">0.00%</span>
                  </li>
                </ul>
              </div>

              {/* Chart Placeholder Box */}
              <div
                style={{
                  width: "60%",
                  height: "140px",
                  backgroundColor: "#fafafa",
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src="/mnt/data/aee36348-d3f6-422c-b27d-2320ec834e48.png"
                  alt="Chart"
                  style={{
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </Row>

      {/* <Row>
         <div className="card mb-4">
        <div className="card-header fw-bold">Social Listening</div>
        <div className="card-body">
          <div className="mb-3">
            <button className="btn btn-outline-primary me-2">All</button>
            <button className="btn btn-outline-secondary me-2">YouTube</button>
            <button className="btn btn-outline-secondary">TikTok</button>
          </div>
          <div className="mb-3 d-flex gap-2">
            <select className="form-select w-auto">
              <option>Sort: Most Viewed</option>
            </select>
            <select className="form-select w-auto">
              <option>Creation time</option>
            </select>
            <select className="form-select w-auto">
              <option>Video duration</option>
            </select>
            <button className="btn btn-outline-secondary">Download</button>
            <button className="btn btn-outline-primary">Search History</button>
          </div>
          {[1, 2, 3].map((video, i) => (
            <div key={i} className="card mb-2">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div className="me-3" style={{ width: "100px", height: "60px", backgroundColor: "#ddd" }}>
                  </div>
                  <div>
                    <h6 className="mb-1">Video Title</h6>
                    <small>Pingrow - Apr 29 2025</small>
                  </div>
                </div>
                <div className="text-end">
                  <small>1.4K • 14 • 47</small>
                  <br />
                  <a href="#">https://youtube.com/video</a>
                </div>
              </div>
            </div>
          ))}
          <div className="text-center p-4 border rounded bg-light">
            <p>
              <strong>Unlock to view 6 social media results.</strong>
            </p>
            <button className="btn btn-primary">View Now ➜</button>
          </div>
        </div>
      </div>
      </Row> */}

      <Row className="px-3 px-md-0" id="embed">
        <div
          className="card embed-section shadow-sm  p-4 d-flex flex-md-row flex-column justify-content-between align-items-start gap-4 bg-white"
          style={{
            borderRadius: "6px",
            backgroundColor: "#fff",
            border: "1px solid #0000002d",
          }}
        >
          {/* Left Section */}
          <div className="flex-grow-1">
            <div className="card-header bg-transparent border-0 px-0">
              <h5 className="fw-bold mb-2">Piny Launch embeds</h5>
            </div>
            <div className="card-body px-0 pt-0">
              <p className="text-muted mb-0">
                Use website badges to drive support from your community for your
                Toolify Launch. They're easy to embed on your homepage or
                footer.
              </p>
            </div>
          </div>

          {/* Right Section */}
          <div className="right-box text-md-end text-start">
            <div className="btn-group mb-3 theme-buttons" role="group">
              <button className="btn btn-sm btn-theme active">Light</button>
              <button className="btn btn-sm btn-theme">Neutral</button>
              <button className="btn btn-sm btn-theme">Dark</button>
            </div>

            <div className="badge-box mb-3">
              <div className="badge-preview">
                <span className="badge-icon">🟣</span>
                <span className="badge-text fw-bold">Toolify.ai</span>
                <span className="badge-star">⭐</span>
              </div>
            </div>

            <div className="d-flex justify-content-end">
              <button className="btn btn-sm btn-outline-purple me-2">
                Copy embed code
              </button>
              <button className="btn btn-sm btn-light border">
                How to install?
              </button>
            </div>
          </div>
        </div>
      </Row>

      <Row className="px-3 px-md-0 " id="alternatives">
        <div
          className="card mb-4 shadow-sm p-4 bg-white mt-4"
          style={{
            borderRadius: "6px",
            backgroundColor: "#fff",
            border: "1px solid #0000002d",
          }}
        >
          <div className="card-header fw-bold bg-white border-0 px-0">
            Alternative of Piny
          </div>
          <div className="card-body px-0">
            <div className="row">
              {[1, 2, 3].map((card, index) => (
                <div key={index} className="col-md-4 mb-4">
                  <div className="card h-100 shadow-sm rounded-3 alt-tool-card border-0">
                    <div
                      className="card-img-top alt-tool-img rounded-top"
                      style={{
                        height: "160px",
                        background:
                          "linear-gradient(to right, #d6c2f1, #dce4f9)",
                      }}
                    ></div>
                    <div className="card-body">
                      <h5 className="fw-semibold mb-1">Tool Name</h5>
                      <p className="text-muted small mb-2">
                        Short description of the tool, features, and purpose.
                      </p>
                      <div className="mb-3">
                        {["Tag1", "Tag2", "Tag3", "Tag4"].map((tag, i) => (
                          <span
                            key={i}
                            className="badge rounded-pill bg-light text-dark me-1 mb-1"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                      <button className="btn btn-outline-purple btn-sm rounded-pill px-4">
                        Open site
                      </button>
                      <small
                        className="d-block mt-3 text-muted fw-normal"
                        style={{ fontSize: "12px" }}
                      >
                        Search: 47.56% | Direct: 32.04% | Referrals: 13.49%
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center mt-3">
              <button className="btn btn-outline-purple rounded-pill px-4">
                Piny Alternative ➜
              </button>
            </div>
          </div>
        </div>
      </Row>
    </Container>
  );
}
